import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'
import {Input, Button} from 'antd'
import {MinusCircleFilled, PlusCircleFilled} from '@ant-design/icons'

import './index.less'
import './mobile.less'
import noImage from '@/assets/img/icon/noImage.png'
import favoriteDefaultIcon from '@/assets/img/icon/favoriteDefault.png'
import favoriteActiveIcon from '@/assets/img/icon/favoriteActive.png'
import {LANGUAGE_CHINESE_KEY} from '@/constants'
import {getFormatMoney} from '@/common'
import {PRODUCT_ITEM_BTN_TYPE_1, PRODUCT_ITEM_BTN_TYPE_2, PRODUCT_ITEM_BTN_TYPE_3} from '@/constants'

const defaultProps = {
  img: noImage,
  price: '',
  name: '',
  description: '',
  btnText: 'Add to cart',
  onProductItemClick: () => {},
  onBtnClick: () => {},
  productType: null,
  isShowPrice: false,
  isFormatPriceToMoney: false,
  isFavorited: false,
  isShowFavorite: false,
  onFavoriteIconClick: () => {},
  quantity: 0,
  btnType: PRODUCT_ITEM_BTN_TYPE_1,
  onMinBtnClick: () => {},
  onPlusBtnClick: () => {},
  onQtyChange: () => {},
  isPromotion: false,
  stock: 999,
  isOverSaleable: false,
  minQty: 0,
  maxQty: 0,
  size: '',
}
export default function ProductItem(props) {
  const options = Object.assign({}, defaultProps, props)
  const {t} = useTranslation()
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'product-item-mobile-container' : 'product-item-container'
  const {locale, isSCM} = commonState
  const {price, isShowPrice, isFormatPriceToMoney} = options
  const showFavoriteIcon = options.isFavorited ? favoriteActiveIcon : favoriteDefaultIcon
  const [qtyInput, setQtyInput] = useState(String(options.quantity ?? 0));

  useEffect(() => {
    setQtyInput(String(options.quantity ?? 0));
  }, [options.quantity]);

  const handleProductItemClick = () => {
    options.onProductItemClick()
  }
  const handleBtnClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
    options.onBtnClick()
  }
  const handleFavoriteIconClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
    options.onFavoriteIconClick()
  }
  const handleType2BtnContainerClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }
  if (options.inventoryQuantity <= 0 && !options.isOverSaleable) {
    options.btnType = PRODUCT_ITEM_BTN_TYPE_3
    options.btnText = 'Coming soon'
  }

  // const disablePlusBtnClick = options.isOverSaleable || options.quantity + 1 > options.stock
  const disablePlusBtnClick = options.isOverSaleable ? false : Number(options.quantity) >= Number(options.inventoryQuantity)
  const isOutOfStock = options?.isOverSaleable ? false : options.inventoryQuantity <= 0
  const isUnderMin = options?.isOverSaleable ? false : options.inventoryQuantity < options.minQty
  
  return (
    <div className={rootClassName}>
      <div className={'product-item-img-container'}>
        {options.img ? <img onClick={handleProductItemClick} src={options.img} alt=""/> : <img src={noImage} onClick={handleProductItemClick} alt=""/>}
        {
          options.isShowFavorite &&
          <div
            className={'product-item-favorite-icon-container'}
            onClick={handleFavoriteIconClick}>
            <img src={showFavoriteIcon} alt="" />
          </div>
        }
        {options.isPromotion && <div className="product-item-promotion-icon-container">
          <img src={require('../../assets/img/icon/discountIcon.png')} alt="" />
        </div>}
      </div>
      {
        (isShowPrice) &&
        <div className={'product-item-price overflow-ellipsis-1'}>
          <span>
            ${isFormatPriceToMoney ? getFormatMoney(price) : Number(price).toFixed(2)}
          </span>
          {
            options.isPromotion &&
            <span class="price_original">
              ${options.originalPrice ? options.originalPrice.toFixed(2) : ''}
            </span>
          }
        </div>
      }
      {
        (options.inventoryQuantity > options.maxQty) ? 
          <div className={'product-item-des overflow-ellipsis-2'}>
            Available
          </div> 
          :
          <div className={'product-item-des overflow-ellipsis-2'}>
            Ready: {options.inventoryQuantity}
          </div>
      }
      <div className={'product-item-des overflow-ellipsis-2'}>
        Pending: {options.pendingQuantity}
      </div> 
      <div className={'product-item-des overflow-ellipsis-2'}>
        {
          (locale === LANGUAGE_CHINESE_KEY) ? <span>{options.description}</span> : <span>{options.name}</span>
        }
      </div>
      {!!options.size && 
        <div className={'cat-item-des overflow-ellipsis-2'}>
          <span>Size: {options.Size}</span>
        </div>}
      {/* <div className={'product-item-des overflow-ellipsis-2 hot'}>
        {options.discountDescription}
      </div> */}
      {!isSCM && <div>
        {
          (options.btnType === PRODUCT_ITEM_BTN_TYPE_1) && (
          isOutOfStock ? (
            <Button
              className={'product-item-btn-disabled'}
              disabled={true}>
              {t('Coming soon')}
            </Button>
          ) : (
            <Button
              className={isUnderMin ? 'product-item-btn-disabled' : 'product-item-btn'}
              disabled={isUnderMin}
              onClick={handleBtnClick}>
              {t(options.btnText)}
            </Button>
          ))
        }
        {
          (options.btnType === PRODUCT_ITEM_BTN_TYPE_2) &&
          <div className={'product-item-type-2-btn-container'} onClick={handleType2BtnContainerClick}>
            <MinusCircleFilled
              className={'product-item-type-2-btn-min-icon'}
              onClick={options.onMinBtnClick}
            />
            <div className={'product-item-type-2-btn-qty'}>
              <Input
                className="qty-input"
                // value={options.quantity}
                value={qtyInput}
                onChange={(e) => {
                  const val = e.target.value;
                  // allow empty string while typing
                  if (val === '' || /^\d+$/.test(val)) {
                    const num = Number(val);
                    // limit to inventoryQuantity
                    if (options.isOverSaleable) {
                      setQtyInput(val);
                    } else {
                      if (val === '' || num <= options.inventoryQuantity) {
                        setQtyInput(val);
                      } else {
                        setQtyInput(String(options.inventoryQuantity));
                      }
                    }
                  }
                }}
                onBlur={() => {
                  let num = Number(qtyInput);
                  if (!options.isOverSaleable) {
                    if (isNaN(num)) {
                      num = options.quantity ?? 0;
                    }
                    if (num > options.inventoryQuantity) {
                      num = options.inventoryQuantity;
                    }
                  } 
                  setQtyInput(String(num));
                  options.onQtyChange(num);
                }}
                onClick={(e) => e.stopPropagation()} // prevent triggering parent onClick
              />
              {/*{options.quantity}*/}
            </div>
            <PlusCircleFilled
               className={`product-item-type-2-btn-plus-icon${disablePlusBtnClick ? ' is-disabled' : ''}`}
              disabled={disablePlusBtnClick}
              onClick={() => {
                if (!disablePlusBtnClick) {
                  options.onPlusBtnClick()
                }
              }}
            />
          </div>
        }
        {
          (options.btnType === PRODUCT_ITEM_BTN_TYPE_3) &&
          <div className={'product-item-btn-disabled'}>
            {t(options.btnText)}
          </div>
        }
      </div>}
    </div>
  )
}
